// Styles
import '@mdi/font/css/materialdesignicons.css'
import 'vuetify/styles'

// Vuetify (components and directives are auto-imported by vite-plugin-vuetify)
import { createVuetify } from 'vuetify'

export default createVuetify({
  ssr: true,
  theme: {
    defaultTheme: 'dark'
  }
})
